import { Routes, Route } from "react-router-dom";

import { FoxgloveIntegration } from "./FoxgloveIntegration";
import { S3Integration } from "./S3Integration";

export function IntegrationsRoutes() {
  return (
    <Routes>
      <Route path="foxglove" element={<FoxgloveIntegration />} />
      <Route path="s3" element={<S3Integration />} />
    </Routes>
  );
}
